// import { GeneralUsageInfo, LandingLayout } from '@modules/landing'
import { ShutdownLanding } from '@ui/components/layouts/shutdown-landing'

function HomeLandingPage() {
  return <ShutdownLanding />
}

export default HomeLandingPage
